import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import OurCoreServices from "./sections/OurCoreServices";
import HowWeWork from "./sections/HowWeWork";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <ServicesOverview />
      <OurCoreServices />
      <HowWeWork />
      <Footer />
    </div>;
}